var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.1568 17.7534L17.7464 13.3429C18.8082 11.9293 19.3814 10.2087 19.3795 8.44073C19.3795 3.92479 15.7054 0.250732 11.1895 0.250732C6.67357 0.250732 2.99951 3.92479 2.99951 8.44073C2.99951 12.9567 6.67357 16.6307 11.1895 16.6307C12.9575 16.6327 14.6781 16.0594 16.0917 14.9976L20.5022 19.4081C20.7254 19.6076 21.0166 19.7142 21.3159 19.7058C21.6153 19.6974 21.9001 19.5748 22.1118 19.363C22.3235 19.1513 22.4462 18.8665 22.4546 18.5672C22.463 18.2678 22.3564 17.9766 22.1568 17.7534ZM5.33951 8.44073C5.33951 7.28371 5.68261 6.15267 6.32541 5.19064C6.96822 4.22862 7.88186 3.47881 8.95081 3.03604C10.0198 2.59326 11.196 2.47741 12.3308 2.70314C13.4656 2.92886 14.5079 3.48602 15.3261 4.30416C16.1442 5.12229 16.7014 6.16466 16.9271 7.29945C17.1528 8.43424 17.037 9.61048 16.5942 10.6794C16.1514 11.7484 15.4016 12.662 14.4396 13.3048C13.4776 13.9476 12.3465 14.2907 11.1895 14.2907C9.63856 14.2889 8.15167 13.6719 7.05499 12.5752C5.95831 11.4786 5.34137 9.99167 5.33951 8.44073Z",
    fill: "#718096"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.31ee4358557d4fd21c035e56be820540.svg";
export { ForwardRef as ReactComponent };